module.exports = __webpack_public_path__ + "img/diventa-donatore.684bd249.jpg";